import { render, staticRenderFns } from "./syncChild.vue?vue&type=template&id=16e54867&"
import script from "./syncChild.vue?vue&type=script&lang=js&"
export * from "./syncChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports